require('./webhook_form')
require('admin/audio/audio_modal')
import {confirmPlus} from 'admin/common/custom_confirm'
import { TagInput } from './tag_input'
import { SevenDayCallCountModal } from './seven_day_call_count_modal';
import { TenDLCCampaignModal } from './ten_dlc_campaign'
import {DataBinder} from 'utils/data_binder'
import {AuditLog} from '../common/audit-log'

export class EditCampaign extends HTMLElement {
  constructor(is_admin, campaign_id, defaults) {
    super();
    this._is_admin = is_admin;
    this._campaign_id = campaign_id;
  }

  async connectedCallback() {
    this.domain_id = document.querySelector("#object_id").value
    pageLoadingFrame("show")
    let res = await fetch(`/admin/campaigns/${this._campaign_id}/detail`);
    let json = await res.json();
    let default_fetch = await fetch(`/admin/domains/${this.domain_id}/campaign_defaults`);
    let defaults = await default_fetch.json();
    this.default_tags = defaults.tag_groups.map(tag => tag.tag_group_id);
    this._data = json.data;
    this._meta = json.meta;
    this.status = this._data.status;
    this.target_type = null;
    if(this._data.target_id) {
      this.target_type = "CALL_TREATMENT";
    } else if (this._data.default_target) {
      this.target_type = this._data.default_target.target_type;
    }
    this.domain_data_binder = new DataBinder(`/admin/domains/${this.domain_id}.json`, true);
    this.domain_data_binder.register(this);
    if(this.domain_data_binder.data) this.requestUpdate(this.domain_data_binder.data);
    console.log(this._data)
  }

  disconnectedCallback(){
    this.domain_data_binder.unregister(this);
  }

  async requestUpdate(domain_data) {
    pageLoadingFrame("hide")

    this.domain = domain_data
    let cleaned =  ('' + this._data.did).replace(/\D/g, '');
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    let did = match ? `(${match[1]}) ${match[2]}-${match[3]}` : '';
    let consumer_greeting = this.target_type == 'DEFAULT' ?  this.getAudioIdForActionTiming(this._data, 1) : null;
    let sales_rep_whisper = this.target_type == 'DEFAULT' ? this.getAudioIdForActionTiming(this._data, 3) : null;
    let webhooks = this.target_type == 'DEFAULT' ? this._data.default_target.children[0].target_child_actions.filter(obj => obj.action.action_type == 'WEBHOOK' || obj.action.action_type == 'EMAIL') : null;
    let representive_code = this.target_type == 'DEFAULT' && this._data.default_target.children[0].target_child_actions.filter(obj => obj.action.action_type == 'REP_CODE').length > 0 ? 1 : 0;
    let voicemail_enabled = this.target_type == 'DEFAULT' && this._data.default_target.children[0].destination.children && this._data.default_target.children[0].destination.children.filter(obj => obj.description == 'Voicemail Target').length > 0 ? 1 : 0;
    let voicemail_greeting = this.target_type == 'DEFAULT' && voicemail_enabled && this._data.default_target.children[0].destination.children[0].destination.target_audio ? this._data.default_target.children[0].destination.children[0].destination.target_audio.target_audio_id : null;
    let voicemail_rollover_time = this.target_type == 'DEFAULT' && voicemail_enabled ? this._data.default_target.children[0].destination.children[0].failure_timeout : 0;

    this.innerHTML = 
      `
      <style>
        edit-campaign .fas {
          font-family: FontAwesome;
        }
        edit-campaign h3 {
          margin-left: -22px;
        }
        edit-campaign .form-group-separated {
          border-top: 1px solid #D5D5D5;
        }
        edit-campaign #call-options {
          margin-top: 30px;
        }
        #edit-disclaimer-panel div:nth-child(n+2) {
          margin: 6px 0 6px 160px;
        }
  
        
        #edit-disclaimer-panel label:nth-child(n+2) {
          font-weight: 500;
        }
        
        #edit-disclaimer-panel input[type='radio'] {
          margin-top: -2px;
          vertical-align: middle;
        }
        edit-campaign .selectize-control.multi .selectize-input>div {
          color: #FFF;
        }
        #edit-campaign-panels {
          padding-left: 20px;
        }
        #edit-campaign-radio {
          margin-left: 50px;
        }
        #edit-campaign-radio label {
          margin: 20px 60px 20px 0;
        }
        #edit-step-2-audio {
          padding: 0;
        }
        .campaign_webhooks_container webhook-form .add_webhook {
          display: none;
        }
  
        .campaign_webhooks_container webhook-form:last-child .add_webhook {
            display: inline-block;
        }
  
        .campaign_webhooks_container webhook-form:only-child .remove_webhook {
            display: none;
        }
  
        edit-campaign webhook-form .col-md-2 {
          line-height: 36px !important;
          font-size: 18px;
        }
        edit-campaign #voicemail_rings_container {
          padding-left: 0 !important;
        }
  
        #edit-call-treat-panel label {
          margin-top: 20px;
        }
        .edit-campaign-buttons {
          margin-left: 38px;
        }
        
        *.edit-campaign-stats {
          height: 65px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-bottom: 5px;
        }
        .edit-campaign-stats:nth-child(3) {
          align-items: flex-end;
        }
        .edit-active {
          color: green;
          font-weight: bold;
        }
        .edit-paused {
          color: red;
          font-weight: bold;
        }
        .campaign-status-toggle {
          cursor: pointer;
        }
        edit-campaign .selectize-control {
          margin-bottom: 20px;
        }
        .form-group {
          margin-bottom: 20px;
        }
        .form-horizontal .control-label {
          line-height: 1.42857143;
        }
        .control-label i {
          font-style: italic;
          font-weight: normal;
        }  
      </style>
      <div class="row">
        <div class="col-lg-7 col-md-12 col-lg-offset-2" id="edit-campaign-main">
          <h3><span id="edit-campaign-back"></span> Edit Campaign ${(did)}</h3>
          <div class="row" style="width:105%;margin-left:-10px;">
            <div class="col-sm-6 edit-campaign-stats">
              <p>Created on: ${this._data.created_at.slice(0, 10)||''}</p>
              <p>By: ${this._meta.creator||''}</p>
            </div>
            <div class="col-sm-3 edit-campaign-stats">
              <b id="edit-campaign-status">${this.status == 3 ? "<br>" : (this.status == 1 ? `<p>Status: <span id='edit-active' class='edit-active' data-cy="edit-active">Active</span> | 
              <span id='edit-paused' class='campaign-status-toggle' data-cy="edit-paused">Pause</span></p>` : `<p>Status: <span id='edit-active' class='campaign-status-toggle data-cy="edit-active"'>Active</span> | 
              <span id='edit-paused' class='edit-paused' data-cy="edit-paused">Pause</span></p>`)}</b>
              <span><b>Changes:</b> <audit-log href="/admin/campaigns/${this._campaign_id}/audits"></audit-log></span>
            </div>
            <div class="col-sm-3 edit-campaign-stats" style="text-align: right;">
              ${this._is_admin ? '<button class="btn btn-outline-danger" id="archive-campaign-button"><span class="fas fa-archive"></span> Delete</button>' : ''}
              <b><span>7 Day Call Count: <a class="recent_calls" href="#">(${this._meta.recent_call_count||0})</a></span></b>
            </div>
          </div>
          <div id="edit-campaign-panels">
            <div class="panel panel-default campaign-panel">
              <div class="errors errors-1" data-cy="errors-1"></div>
              <label>Name</label>
              <input type="text" class="form-control" id="edit-campaign-name" data-cy="campaign-name" placeholder="e.g., google.com" value="${this._data.campaign_name}">
            
              <div class="tags-container"></div>
              
              <div class="row" id="edit-call-options" style="margin-top: 20px">
              
                <div class="col-sm-6 col-xs-12">
                  <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
                    <label class="col-md-6 control-label" style="text-align:left">CallShield</label>
                    <div class="col-md-6"  align="left">
                      <label class="switch">
                        <input type="checkbox" class="form-control switch" id="edit-call-shield-switch" ${this._data.callshield ? "checked" : ""}>
                        <span data-cy="call-shield-switch"></span>
                      </label>
                    </div>
                  </div>
                  <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
                    <label class="col-md-6 control-label" style="text-align:left">LeadScore</label>
                    <div class="col-md-6"  align="left">
                      <label class="switch">
                        <input type="checkbox" class="form-control switch" id="edit-lead-score-switch" ${this._data.call_processing_map ? "checked" : ""}>
                        <span data-cy="lead-score-switch"></span>
                      </label>
                    </div>
                  </div>
                  <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
                    <label class="col-md-6 control-label" style="text-align:left">Call Recording
                    <span>
                      <span class="fa fa-question-circle" data-toggle="tooltip" data-placement="right" data-html="true" 
                        title="<p style='text-align:left'>Call Recording includes a Recording Disclaimer to announce this call is being recorded</p>"</span>
                        </span>                                                                            
                    </label>
                  <div class="col-md-6"  align="left">
                    <label class="switch">
                      <input type="checkbox" class="form-control switch" id="edit-call-rec-switch" ${this._data.enable_call_recording ? "checked" : ""}>
                        <span data-cy="call-rec-switch"></span>
                          </label>
                    </div>
                  </div>



              ${this._is_admin ? `
              <div class="dni-speech-transcription-enabled" id="redaction-panel">
                <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
                  <label class="col-md-6 control-label" style="text-align:left">Speech Transcription
                  </label>
                  <div class="col-md-6"  align="left">
                    <label class="switch">
                      <input type="checkbox" class="form-control switch" id="speech-transcription-enabled-switch" ${this._data.speech_transcription ? 'checked' : ''}>
                      <span data-cy="speech-transcription-enabled-switch"></span>
                    </label>
                  </div>
                </div>
                <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">

                  <label class="col-md-6" align="left">Redaction
                  </label>
                  <div class="col-md-6"  align="left">
                    <label class="switch">
                      <input type="checkbox" class="form-control switch" 
                      ${this._data.speech_transcription ? '' : 'disabled'}
                      id="redaction-enabled-switch" ${this._data.redaction ? 'checked' : ''}>
                      <span data-cy="redaction-enabled-switch"></span>
                    </label>
                  </div>

                </div>
              </div> 
              ` : ``}

                </div>
                <div class="col-sm-6 col-xs-12">
                <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
                ${this.isTollFree() ? '' : `<label class="col-md-8 no-gutters control-label" style="text-align:left"">Texting Enabled <br></label>
                <div class="col-md-4"  align="right">
                  <label class="switch"><input type="checkbox" class="form-control switch" id="edit-texting-switch" ${this._data.did_texting_enabled == 1 || this._data.did_texting_enabled == 2 ? "checked" : ""} ${this._data.did_texting_enabled == 1 || this._data.did_texting_enabled == 3 ? "disabled" : ""}><span data-cy="texting-switch"></span></label>
                </div>`}
              </div>
             ${this.isTollFree() || this.domain.site.tnid_brand != null ? `<div id="outbound-texting-switch" class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form" style="${this._data.did_texting_enabled == 1 || this._data.did_texting_enabled == 2 ? "" : "display:none"}"><label class="col-md-8 no-gutters control-label"  style="text-align:left">Outbound Texting</label>
                                      <div class="col-md-4"  align="right">
                                        <label class="switch"><input type="checkbox" class="form-control switch" id="outbound-texting-enabled" ${this._data.enable_outbound_sms == 1 ? "checked" : ""}><span data-cy="outbound-texting-switch"></span></label>
                                      </div>
                                    </div>` : ''}
                                    <div class="campaign_team col-sm-12 ${this._data.did_texting_enabled == 1 || this._data.did_texting_enabled == 2 ? "" : "hidden"}">
                                    <label>Team</label>
                                    <select name="teams" is="teams-select" class="select-teams form-control" data-selected="${this._data.texting_team_id}"></select>
                                    <label>Chat Treatment</label>
                                    <select name="" id="chat_message_tree_id" is="message-treatments-select" class="form-control" data-selected="${this._data.message_tree_id}" domain_id="${this.domain_id}" type="chat"></select>
                                  </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" id="edit-disclaimer-panel" data-cy="call-disclaimer" style="padding-left: 15px">
                
                  <div>
                    <label>Recording Announcement</label>&nbsp<span>(Please select language):</span>
                  </div>
                  <div>
                    <input type="radio" name="disclaimer-lang" value="1" id="edit-disclaimer-english" data-cy="lang-english" ${this._data.call_disclaimer === 1 ? 'checked':''}>
                    <label>English</label>
                  </div>
                  <div>
                    <input type="radio" name="disclaimer-lang" value="2" id="edit-disclaimer-spanish" data-cy="lang-spanish" ${this._data.call_disclaimer === 2 ? 'checked':''}>
                    <label>Spanish</label>
                  </div>
                  <div>
                    <input type="radio" name="disclaimer-lang" value="3" id="edit-disclaimer-french" data-cy="lang-french" ${this._data.call_disclaimer === 3 ? 'checked':''}>
                    <label>French</label>
                  </div>
                  ${this._is_admin || (this._data.enable_call_recording && this._data.call_disclaimer == 0) ? `<div><input type="radio" name="disclaimer-lang" value="0" id="edit-disclaimer-none" data-cy="lang-none" ${this._data.call_disclaimer === 0 ? 'checked':''}> <label>None</label></div>` : ''}
                </div>                
                
                
                </div>
                
                ${this.domain.site.tnid_brand != null ?
                `<div class="ten-dlc-campaign-container row ${this._data.did_texting_enabled == 1 || this._data.did_texting_enabled == 2 && this._data.enable_outbound_sms == 1 ? '' : 'hidden'}">
                  <div class="col-sm-6 no-gutters">
                    <label>10DLC Campaign</label>
                    <br>
                    <span>*Required for outbound texting</span>
                  </div>
                  <div class="col-sm-6 no-gutters" id="ten-dlc-campaign-container">
                  </div>
                </div>` : ''}

              </div>
            </div>
            <div id="edit-campaign-radio">
              <input type="radio" name="edit-camp-radio-toggle" id="edit-ring-to-radio" data-cy="ring-to-radio" ${!this._data.target_id ? 'checked' : ''}>
              <label>Ring to Number</label>
              <input type="radio" name="edit-camp-radio-toggle" id="edit-call-treat-radio" data-cy="call-treat-radio" ${this._data.target_id ? 'checked' : ''}>
              <label>Call Treatment</label>
            </div>
            <div class="panel panel-default campaign-panel">
              <div class="errors errors-2" data-cy="errors-2"></div>
              <div id="edit-ring-to-panel" data-cy="ring-to-panel" ${this._data.target_id ? 'style="display:none;"' : ''}>
                <input type="text" is="ring-to-endpoint" class="form-control ring_to_endpoint" id="edit-camp-rtn" data-cy="edit-camp-rtn" data-key="ring_to_endpoint" placeholder="(123) 444-5566 or SIP Target" value="${this._data.ring_to_endpoint||''}">
                <div id="edit-step-2-audio" class="col-sm-12">
                  <div><label>Consumer Greeting</label></div>
                  <div class="col-sm-12 no-gutters audio-select-row">
                    <select is=audio-select target_audio_type=2 class="form-control" id="edit-consumer-greeting-select" data-cy="consumer-greeting" data-selected=${this.target_type == 'DEFAULT' ? consumer_greeting : null}></select>
                    <button class="btn btn-secondary ct_manage_audio" data-audio-type-id="2">Manage</button>
                  </div>
                  <div><label>Sales Rep Whisper</label></div>
                  <div class="col-sm-12 no-gutters audio-select-row">
                    <select is=audio-select target_audio_type=4 class="form-control" id="edit-sales-rep-select" data-cy="sales-rep-whisper" data-selected=${this.target_type == 'DEFAULT' ? sales_rep_whisper : null}></select>
                    <button class="btn btn-secondary ct_manage_audio" data-audio-type-id="4">Manage</button>
                  </div>
                </div>

                <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 no-gutters" align="right" role="form">
                  <label class="col-md-6 no-gutters" align="left">Call Ends - Assign Representative Code</label>
                  <div class="col-md-6"  align="left">
                    <label class="switch">
                      <input type="checkbox" class="form-control switch" id="representive-code-switch" ${this.target_type == 'DEFAULT' && representive_code == 1 ? "checked" : ""}>
                      <span data-cy="representive-code-switch"></span>
                    </label>
                  </div>
                </div>
                <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 no-gutters" align="right" role="form">
                  <label class="col-md-6 no-gutters" align="left">Voicemail</label>
                  <div class="col-md-2"  align="left">
                    <label class="switch">
                      <input type="checkbox" class="form-control switch" id="voicemail-switch" ${this.target_type == 'DEFAULT' && voicemail_enabled == 1 ? "checked" : ""}>
                      <span data-cy="voicemail-switch"></span>
                    </label>
                  </div>
                  <div id="voicemail_rings_container" class="col-md-4 ${this.target_type == 'DEFAULT' && voicemail_enabled == 1 ? "" : "hidden"}">
                    <label class="col-md-6">Number of Rings</label>
                    <div class="col-md-6 no-gutters">
                      <select id="voicemail_rings" class="form-control">
                        <option value="0">0</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div id="voicemail_audio" class="col-sm-12 no-gutters ${this.target_type == 'DEFAULT' && voicemail_enabled == 1 ? "" : "hidden"}">
                  <div class="col-sm-12 no-gutters"><label>Voicemail Greeting</label></div>
                  <div class="col-sm-12 no-gutters audio-select-row">
                    <select is=audio-select target_audio_type=6 class="form-control" id="voicemail-greeting-select" data-cy="voicemail-greeting-select" default_option_text="Default" data-selected=${this.target_type == 'DEFAULT' ? voicemail_greeting : null}></select>
                    <button class="btn btn-secondary ct_manage_audio" data-audio-type-id="6">Manage</button>
                  </div>
                </div>

                <div class="panel-body form-group-separated form-horizontal">
                  <div>
                    <label class="control-label" style="margin-top: 20px">Webhook</label>
                  </div>
                  <div class="campaign_webhooks_container" data-cy="campaign-webhooks">
                    ${webhooks != null && webhooks.length > 0 ? webhooks.map(webhook => `<webhook-form data-action-id=${webhook.action_id} data-action-timing=${webhook.action_timing}></webhook-form>`).join("") : "<webhook-form></webhook-form>"}
                  </div>
                </div>
              </div>
              <div id="edit-call-treat-panel" data-cy="call-treat-panel" ${!this._data.target_id ? 'style="display:none;"' : ''}>
                <label>Call Treatment</label>
                <select is=treatments-select class="form-control call_treatments_id" data-cy="call-treat-id" domain_id="${this._data.domain_id}" data-selected="${this._data.target_id||''}"></select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 edit-campaign-buttons">
              <button type="button" class="btn btn-primary save pull-right campaign-row-button" data-cy="save-campaign-edit">Save</button>
              <button type="button" class="btn btn-outline-secondary cancel pull-right campaign-row-button">Cancel</button>
            </div>
          </div>
        </div>
      </div>
      `;

    this.querySelector(".tags-container").appendChild(new TagInput(this.domain_id, this._data.campaign_tags, this.default_tags));

    if(!this.querySelector('#edit-call-rec-switch').checked) {
      this.querySelector('#edit-disclaimer-panel').classList.add('hidden');
      if(this._is_admin) {
        this.querySelector('.dni-speech-transcription-enabled').classList.add('hidden');
      }
    }

    this.querySelector('#edit-campaign-status').addEventListener('click', function(e) {
      this.toggleStatus(e);
    }.bind(this))

    this.querySelector('#edit-campaign-back').addEventListener('click', function() {
      this.cancelEdit();
    }.bind(this))

    //Delete button
    if(this.querySelector('#archive-campaign-button')) {
      this.querySelector('#archive-campaign-button').addEventListener('click', function(e) {
        this.archive(e);
      }.bind(this))
    }

    if(this.querySelector('#ten-dlc-campaign-container') != undefined) {
      let ten_dlc_campaign = new TenDLCCampaignModal(this._data, this.domain.site, function(campaign){this._data = campaign}.bind(this));
      this.querySelector('#ten-dlc-campaign-container').appendChild(ten_dlc_campaign)
    }

    this.querySelector('.cancel').addEventListener('click', function(e) {
      e.preventDefault();
      this.cancelEdit();
    }.bind(this))

    this.querySelector('.save').addEventListener('click', function(e) {
      e.preventDefault();
      this.saveEdit();
    }.bind(this))

    //Recent calls
    this.querySelector('.recent_calls').addEventListener('click', function(e) {
      e.preventDefault();
      let recent_calls = new SevenDayCallCountModal(this._campaign_id)
      this.appendChild(recent_calls)
      recent_calls.show();
    }.bind(this))

    this.querySelectorAll('#edit-campaign-radio input').forEach(radio => {
      radio.addEventListener('click', function() {
        let ringToPanel = this.querySelector('#edit-ring-to-panel');
        let callTreatPanel = this.querySelector('#edit-call-treat-panel');
        if(this.querySelector('#edit-ring-to-radio').checked){
          ringToPanel.style.display = 'initial';
          callTreatPanel.style.display = 'none';
        } else if(this.querySelector('#edit-call-treat-radio').checked) {
          ringToPanel.style.display = 'none';
          callTreatPanel.style.display = 'initial';
        }
      }.bind(this))
    })

    //Bind input values to this._data values
    this.querySelector('#edit-campaign-name').onchange = (e) => { this._data.campaign_name = e.target.value };
    this.querySelector('.ring_to_endpoint').onchange = (e) => {
      if(this.querySelector(".ring_to_endpoint").value != "") {
        let ring_to = this.querySelector('.ring_to_endpoint').value.split("@");
        if(ring_to.length == 1) {
          this._data.ring_to_number = ring_to[0].replace(/\D/g,'');
          this._data.ring_to_domain = null;
       } else {
          this._data.ring_to_number = ring_to[0].replace(/\D/g,'');
          this._data.ring_to_domain = ring_to[1]
       }
      }
    };
    let sel = this.querySelector('.call_treatments_id');
    sel.onchange = () => this._target_id = sel.value;
    //Set visibility of ring to number
    this._target_id = this._data.target_id;
    this.querySelector('#edit-call-rec-switch').onchange = (e) => { 
      if(e.target.checked) {
        this._data.enable_call_recording = 1;
        this.querySelector('#edit-disclaimer-panel').classList.remove('hidden');
        if(this._is_admin) {
          this.querySelector('.dni-speech-transcription-enabled').classList.remove('hidden');
        }
      } else if (!e.target.checked) {
        this._data.enable_call_recording = 0;
        this.querySelector('#edit-disclaimer-panel').classList.add('hidden');
        if(this._is_admin) {
          this.querySelector('.dni-speech-transcription-enabled').classList.add('hidden');
        }
      }
    };

    if(this._is_admin) {
      this.querySelector('#speech-transcription-enabled-switch').addEventListener('click', function() {
        if(this.querySelector('#speech-transcription-enabled-switch').checked == false) {
          this.querySelector('#redaction-enabled-switch').setAttribute('disabled', true);
        } else {
          this.querySelector('#redaction-enabled-switch').removeAttribute('disabled');
        }
      }.bind(this))
    }

    //Set visibility of call disclaimer
    this.querySelector('#edit-call-shield-switch').onchange = (e) => { this._data.callshield = e.target.checked };
    this.querySelector('#edit-consumer-greeting-select').onchange = (e) => { this._data.consumer_greeting_id = e.target.value == "null" ? null : e.target.value };
    this.querySelector('#edit-sales-rep-select').onchange = (e) => { this._data.sales_rep_whisper_id = e.target.value == "null" ? null : e.target.value };

    
    this.querySelector('#edit-lead-score-switch').onchange = (e) => { 
      this._data.call_processing_map = e.target.checked ? 1 : 0
    };      
  
    let initialTextingValue = this._data.did_texting_enabled

    if(!this.isTollFree()) {
      this.querySelector('#edit-texting-switch').onchange = (e) => { 
        if(initialTextingValue == 2) {
          this._data.did_texting_enabled = e.target.checked ? 2 : 3;
        } else {
          this._data.did_texting_enabled = e.target.checked ? 1 : 0;
        }
  
        if(e.target.checked) {
          this.querySelector(".campaign_team").classList.remove('hidden');
          if(this.isTollFree()){
            this.querySelector("#outbound-texting-switch").classList.remove('hidden');
          }
        }
        else {
          this.querySelector(".campaign_team").classList.add('hidden');
          if(this.isTollFree()){
            this.querySelector("#outbound-texting-switch").classList.add('hidden');
          }
        }
      };
    }
    this.querySelector('.select-teams').onchange = (e) => { this._data.texting_team_id = e.target.value == "" ? null : e.target.value }; 
    this.querySelector('#chat_message_tree_id').onchange = (e) => { this._data.message_tree_id = e.target.value == "null" ? null : e.target.value }; 

    this.querySelector('#voicemail-switch').addEventListener('click', function() {
      if(this.querySelector('#voicemail-switch').checked == false) {
        this.querySelector('#voicemail_rings_container').classList.add('hidden');
        this.querySelector('#voicemail_audio').classList.add('hidden');
      } else {
        this.querySelector('#voicemail_rings_container').classList.remove('hidden');
        this.querySelector('#voicemail_audio').classList.remove('hidden');
      }
    }.bind(this))

    this.querySelector('#voicemail_rings').value = voicemail_rollover_time;
  }

  retrieveWebhooks() {
    let data_set = [];
    this.querySelectorAll("webhook-form").forEach((webhook_form) => {
      let webhook_value = webhook_form.getValue();
      if(webhook_value != null) {
        data_set.push(webhook_value);  
      }
    });
    return data_set;
  }

  async toggleStatus(e) {
    if(this._data.status == 1 && e.target.id == 'edit-paused') {
      if(await confirmPlus(`Are you sure you want to Pause?<br>The Campaign Pause is for 30 days.`)) {
        this.querySelector('#edit-active').classList = ('campaign-status-toggle');
        this.querySelector('#edit-paused').classList = ('edit-paused');
        this.statusPut();
      }
    } else if (this._data.status == 2 && e.target.id == 'edit-active') {
      this.querySelector('#edit-active').classList = ('edit-active');
      this.querySelector('#edit-paused').classList = ('campaign-status-toggle');
      this.statusPut();
    }
  }

  async statusPut() {
    let result = await fetch(`/admin/campaigns/${this._data.id}/toggle`, {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
        'Content-Type': 'application/json'
      },
      // body: JSON.stringify(data)
    })

    let response = await result.json();

    //Call success or failure callback
    if(result.ok && response.success) {
      Common.notify(`${response.msg}`, 'success');
      this.cancelEdit();
      CampaignsList.reloadData();
      TreatmentsManager.reloadTreatments();
    }
    else {
      Common.notify(response.message != null ? response.message : 'Failed to update campaign status.', 'error');
    }
  }

  cancelEdit() {
    this.remove();
    document.querySelector('#campaign_list_items').style.display = 'initial';
  }

  getAudioIdForActionTiming(json, action_timing) {
    let actions_for_timing = json.default_target.children[0].target_child_actions.filter(obj => obj.action.action_type == 'AUDIO' && obj.action_timing == action_timing)
    return actions_for_timing.length > 0 ? actions_for_timing[0].action.action_parameters.filter(obj => obj.parameter_name == 'audio_id')[0].parameter_value : null;
  }

  async saveEdit(){
    pageLoadingFrame("show")
    if(this.validateEdit()) {
      if(this.querySelector('#edit-ring-to-radio').checked){
        this._data.target_id = null;
      } else {
        this._data.target_id = this.querySelector('.call_treatments_id').value;
      }
      this._data.domain_id = this.domain_id
      // Campaign name redundancy for Cypress test
      this._data.campaign_name = this.querySelector('#edit-campaign-name').value

      this._data.campaign_tag_data = this.querySelector("tag-input").getData();

      this._data.enable_outbound_sms = (this.isTollFree() || this.domain.site.tnid_brand != null) && (this._data.did_texting_enabled == 1 || this._data.did_texting_enabled == 2) && 
        this.querySelector("#outbound-texting-enabled") != null && this.querySelector("#outbound-texting-enabled").checked ? 1 : 0
      if(this._data.did_texting_enabled == 1 || this._data.did_texting_enabled == 2) {
        
      }
      this._data.call_disclaimer = this._data.enable_call_recording ? this.querySelector('input[name="disclaimer-lang"]:checked').value : 0;
      this._data.actions = [];
      let consumer_greeting = this.querySelector('#edit-consumer-greeting-select').value;
      if(consumer_greeting != "null") {
        let action = {
          action_timing: 1,
          action_type: "AUDIO",
          action_parameters: [{
            parameter_name: "audio_id",
            parameter_value: consumer_greeting
          }, 
          {
            parameter_name: "channel",
            parameter_value: EditCampaign.CHANNEL_AUDIO_CONSUMER
          }]
        }
        this._data.actions.push(action);
      }
      
      let sales_rep_whisper = this.querySelector('#edit-sales-rep-select').value;
      if(sales_rep_whisper != "null") {
        let action = {
          action_timing: 3,
          action_type: "AUDIO",
          action_parameters: [{
            parameter_name: "audio_id",
            parameter_value: sales_rep_whisper
          }, 
          {
            parameter_name: "channel",
            parameter_value: EditCampaign.CHANNEL_AUDIO_TARGET
          }]
        }
        this._data.actions.push(action);
      }

      if(this.querySelector("#representive-code-switch").checked) {
        this._data.actions.push({
          action_timing: 6,
          action_type: "REP_CODE"
        })
      }

      this.querySelectorAll("webhook-form").forEach((webhook_form) => {
        let webhook_value = webhook_form.getValue();
        if(webhook_value != null) {
          this._data.actions.push(webhook_value);  
        }
      });
      
      this._data.voicemail_enabled = this.querySelector("#voicemail-switch").checked ? 1 : 0;
      if(this.querySelector('#voicemail-switch').checked) {
        this._data.voicemail_rollover_time = this.querySelector("#voicemail_rings").value;
        this._data.voicemail_audio_id = this.querySelector("#voicemail-greeting-select").value == "null" ? null : this.querySelector("#voicemail-greeting-select").value;
      }

      if(this._is_admin) {
        this._data.speech_transcription = this._data.enable_call_recording && this.querySelector('#speech-transcription-enabled-switch').checked ? 1 : 0;
        if (this._data.speech_transcription) {
          this._data.redaction = this.querySelector('#redaction-enabled-switch').checked ? 1 : 0;
        } else {
          // if transcription is off, force redaction to be off too.
          this._data.redaction = 0;
        }
      }

      let data = this._data;
  
      console.log(data);
      //Submit to server
      let result = await fetch('/admin/campaigns/update', {
        method: 'POST',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
  
      let response = await result.json();

      //Call success or failure callback
      if(result.ok && response.success) {
        Common.notify('Saved campaign', 'success');
        this.cancelEdit();
        CampaignsList.reloadData();
        TreatmentsManager.reloadTreatments();
      }
      else {
        Common.notify(response.message != null ? response.message : 'Failed to save campaign.', 'error');
      }
    }
    pageLoadingFrame("hide")
  }

  async archive(e) {
    e.preventDefault();
    if(await confirmPlus("Are you sure you want to Delete this campaign?")){
      if(await confirmPlus("As soon as you Delete you will lose this number. Please confirm?")){
        let res = await fetch(`/admin/campaigns/${this._data.id}`, {
          method: 'DELETE',
          headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json'
          }
        }).catch(e => Common.notify(e, 'error'));
        let json = await res.json();
        if(res.ok){
          Common.notify(json.msg, 'success');
          this.cancelEdit();
          CampaignsList.reloadData();
        } else {
          Common.notify(json.msg, 'danger');
        }
      }
    }
  }

  validateEdit() {
    this.querySelectorAll('.errors').forEach(err => {
      err.innerHTML = "";
    })
    let isValid = true;
    let errors1 = "";
    let errors2 = "";
    if(!this.querySelector('#edit-campaign-name').value) {
      errors1 += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Please provide a campaign name.
                                                  </div>`;
      isValid = false;
    }
    if(this.querySelector('#edit-ring-to-radio').checked && !this.querySelector('#edit-camp-rtn').value) {
      errors2 += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Please provide a phone number.
                                                  </div>`;
      isValid = false;
    }
    if(this._data.did == this._data.ring_to_endpoint) {
      errors2 += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Ring to Number must be different from Tracking Number.
                                                  </div>`;
      isValid = false;
    }
    if(this.querySelector('#edit-call-treat-radio').checked && !this.querySelector('.call_treatments_id').value) {
      errors2 += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Please select a call treatment.
                                                  </div>`;
      isValid = false;
    }
    if(this._data.enable_call_recording && !this.querySelector('input[name="disclaimer-lang"]:checked')) {
      errors1 += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Please choose a disclaimer language.
                                                  </div>`;
      isValid = false;
    }

    if((this._data.did_texting_enabled == 1 || this._data.did_texting_enabled == 2) && (this._data.texting_team_id == "" || this._data.texting_team_id == null)) {
      errors1 += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> A team must manage your incoming text messages.
                                                  </div>`;
      isValid = false;
    }

    if(!this.querySelector("tag-input").validate()) {
      errors1 += `<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> All Campaign Tags must have a Name selected.
                    </div>`;
      isValid = false;
    }

    
    if(this._data.call_processing_map && !this._data.enable_call_recording) {
      errors1 += `<div class="alert alert-danger alert-dismissible" role="alert">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <strong>Warning!</strong> Call Recording must be turned on when turning on LeadScore.
      </div>`;
      isValid = false;
    }   
    
    
    this.querySelector('.errors-1').innerHTML = errors1;
    this.querySelector('.errors-2').innerHTML = errors2;

    return isValid;
  }

  isTollFree() {
    const regex = /^(\+?1)?(8(00|33|44|55|66|77|88)[2-9]\d{6})$/;
    return regex.test(this._data.did);
  }
}

EditCampaign.CHANNEL_AUDIO_CONSUMER = 0;
EditCampaign.CHANNEL_AUDIO_TARGET = 1;

customElements.define('edit-campaign', EditCampaign)

class CampaignDetailsModal extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.innerHTML = 
      `<div class="modal fade bd-example-modal-sm" id="detailsModal" data-cy="details-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title"></h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                
              </div>
            </div>
          </div>
        </div>
      </div>`;
  }
}

customElements.define('campaign-details-modal', CampaignDetailsModal)